import React from 'react';
import { motion } from 'framer-motion';
import { Link2Icon, InfinityIcon, ReceiptIcon, CalculatorIcon, PartyPopperIcon } from 'lucide-react';
const reasons = [{
  icon: Link2Icon,
  title: 'No app required',
  detail: 'Friends can join through a link, QR code or join code, straight from their browser.',
  feature: true
}, {
  icon: InfinityIcon,
  title: 'No limits',
  detail: 'Create as many kitties and add as many people as you need. No subscription.'
}, {
  icon: ReceiptIcon,
  title: 'Receipts included',
  detail: 'Add a photo of the bill so everyone can see exactly what was paid for.'
}, {
  icon: CalculatorIcon,
  title: 'The maths is done for you',
  detail: 'KittyPot shows exactly who owes whom, expense by expense.'
}, {
  icon: PartyPopperIcon,
  title: 'Built for real groups',
  detail: 'Holidays, nights out, housemates, festivals and everyday plans.'
}];
export function WhyKittyPot() {
  return <section id="why-kittypot" aria-labelledby="why-kittypot-heading" className="bg-white py-20 lg:py-28" data-id="element-383" data-mp="3nkfpmrms6r8h">
      <div className="mx-auto max-w-7xl px-6 sm:px-8" data-id="element-384" data-mp="3sdibsep8ayen">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.5
      }} className="mb-12 max-w-2xl" data-id="element-385" data-mp="3ellnklqol8nj">
          <h2 id="why-kittypot-heading" className="text-3xl font-black leading-[1.05] tracking-tight text-kitty-dark md:text-4xl lg:text-5xl" data-id="element-386" data-mp="a4hqag42k8y1">
            Why KittyPot?
          </h2>
        </motion.div>

        <motion.ul initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-60px'
      }} variants={{
        hidden: {},
        visible: {
          transition: {
            staggerChildren: 0.05
          }
        }
      }} className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-387" data-mp="64hbuvgyzxqz">
          {reasons.map(reason => <motion.li key={reason.title} variants={{
          hidden: {
            opacity: 0,
            y: 14
          },
          visible: {
            opacity: 1,
            y: 0,
            transition: {
              duration: 0.35,
              ease: [0.22, 1, 0.36, 1]
            }
          }
        }} className={`flex flex-col rounded-3xl border p-7 ${reason.feature ? 'border-transparent bg-kitty-yellow lg:col-span-1' : 'border-gray-100 bg-white shadow-soft'}`} data-id="element-388" data-mp="wgu6pmsjj2zk">
              <span className={`mb-5 flex h-12 w-12 items-center justify-center rounded-2xl ${reason.feature ? 'bg-white' : 'bg-kitty-yellow-100'}`} data-id="element-389" data-mp="3qlyonrpxyyp">
                <reason.icon className="h-6 w-6 text-kitty-dark" aria-hidden="true" data-id="element-390" data-mp="1y20p76sk02fi" />
              </span>
              <h3 className="mb-2 text-xl font-extrabold text-kitty-dark" data-id="element-391" data-mp="3bzlk3ccjwf3u">
                {reason.title}
              </h3>
              <p className={`text-base leading-relaxed ${reason.feature ? 'text-kitty-dark/80' : 'text-gray-600'}`} data-id="element-392" data-mp="3gxd99ylt9n4c">
                {reason.detail}
              </p>
            </motion.li>)}
        </motion.ul>
      </div>
    </section>;
}